export const BID_AGENT_FORM_KEY_DESKTOP = 'BID_AGENT_FORM_KEY_DESKTOP'

export const BID_FORM_KEY_DESKTOP = 'BID_FORM_KEY_DESKTOP'

export const BID_AGENT_FORM_KEY_MOBILE = 'BID_AGENT_FORM_KEY_MOBILE'

export const BID_FORM_KEY_MOBILE = 'BID_FORM_KEY_MOBILE'
